import { useEffect, type ReactNode } from 'react'

import { getSubReportsInReport, getSubReportsInReportTitles } from './availableReports'
import ReportTabs from './ReportTabs'

type Props = {
  baseUrl: string
  subReport?: string
  redirectToReport: (subReport: string) => void
  report: string
  hideBorderBottom?: boolean
  children: ReactNode
}

const SubReportChooser = ({
  baseUrl,
  subReport,
  redirectToReport,
  report,
  hideBorderBottom,
  children,
}: Props) => {
  const subReports = getSubReportsInReport(report)
  const titles = getSubReportsInReportTitles(report)

  useEffect(() => {
    if (!subReport) {
      redirectToReport(subReports[0])
    }
  }, [report, subReport, subReports, redirectToReport])

  if (!subReport) {
    return null
  }

  return (
    <>
      {subReports.length > 1 && (
        <ReportTabs
          baseUrl={baseUrl}
          currentSubReport={subReport}
          subReports={subReports}
          tabTitles={titles}
          hideBorderBottom={hideBorderBottom}
        />
      )}
      {children}
    </>
  )
}

export default SubReportChooser
